import { observer } from "mobx-react";
import { useUserVesting } from "../../../utils/hooks/presale-manager/read/useUserVesting";
import { useClaimableAmount } from "../../../utils/hooks/presale-manager/read/useClaimableAmount";
import { PRESALE_ID, STATUS } from "../../../utils/constants";
import { useEffect } from "react";
import exchangeInterfaceStore from "../../../stores/ExchangeInterfaceStore";
import ClaimButton from "./ClaimButton";

const Claim = () => {
  const userVesting = useUserVesting()?.data!;
  const claimableAmount = useClaimableAmount(PRESALE_ID)?.claimableAmount!;


  const { setStatus, statuses } = exchangeInterfaceStore;

  useEffect(() => {
    if (!userVesting) return;

    const { claimStart } = userVesting;

    if (claimableAmount <= 0 || claimableAmount === undefined)
      return setStatus(STATUS.NOTHING_TO_CLAIM, true);

    if (claimStart < new Date()) return setStatus(STATUS.VESTING_STARTED, true);

    setStatus(STATUS.NOTHING_TO_CLAIM, false);
    setStatus(STATUS.VESTING_STARTED, false);
  }, [statuses, setStatus, userVesting, claimableAmount]);
  return (
    <div className="flex flex-col justify-center gap-y-6">
      <div className="flex flex-col text-sm my-4 gap-y-2 tracking-wide items-center uppercase font-bold text-neutral-100 ">
      {statuses.WALLET_DISCONNECTED ? (
          <div className="bg-slate-200/30 p-2 rounded-md">Connect wallet to see your tokens</div>
        ) : (
          <>
            <span className="bg-slate-200/30 p-2 rounded-md">
              $PEPE3D bought: {userVesting?.totalAmount}
            </span>
            <span className="bg-slate-200/30 p-2 rounded-md">
              Claimable amount: {claimableAmount ? claimableAmount : "0"}
            </span>
          </>
        )}
      </div>
      <hr className="border-gray-200/90" />
    

      
      <ClaimButton />
    </div>
  );
};
export default observer(Claim);
